// extracted by mini-css-extract-plugin
export default {"featured-posts":"FeaturedPosts_featured-posts__Z54ME"};